export default {
	styleOverrides: {
		root: {
			zIndex: '9999999 !important',
		},
	},
} as any;
